import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const GalleryImage = styled.img`
  width: 100% !important;
  @media (min-width: ${breakpoints.tablet}) {
    width: 50% !important;
  }
`;

export default GalleryImage;



// WEBPACK FOOTER //
// ./src/styled-components/GalleryImage.js